Lang_es_es = {
    lang: 'Idioma',
    es_es: 'Español',
    en_en: 'Ingles',
    Hello: 'Hola',
    Ibero: 'Campus Virtual Universidad IBeroamericana',
    Info: 'informacion',
    User: 'Usuario',
    NameUser: 'Nombre de Usuario',
    Password: 'Constraseña',
    Login: 'Iniciar sesión',
    AlertSecury: 'Alerta de Seguridad',
    MsgAlertSecury: 'El usuario o contraseña ingresado no es valido, por favor intentalo nuevamente.',

    txtIberoPresen: 'Recursos en línea para todos nuestros estudiantes Ibero',
    txtIberoVitual: 'Recursos para nuestros estudiantes virtuales Ibero',
    txtIberoCampus: '',

    /*Menu*/
    Exit: 'Salir',
    Users: 'Usuario',
    Account: 'Cuenta',
    Settings: 'Configuración',
    Update: 'Actualizar',

    Accepted: 'Aceptado',
    NotAccepted: 'No aceptado'
}

